import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Paper,
  Typography,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  FormControlLabel,
  TextField,
  Switch,
  Button,
  Alert,
  CircularProgress,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Avatar,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import baseURL from "../config";
import Navbar from "../Navbar/Navbar.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const predefinedRoutes = [
  {
    group: "Vessel Owner",
    routes: [
      { path: "/api/vesselOwner/getVesselOwnerALL", label: "Get All Vessel Owners" },
      { path: "/api/vesselform", label: "Add Vessel" },
      { path: "/api/getvesselform", label: "Get Vessel Form" },
      { path: "/api/getVesselDetails/:id", label: "Get Particular Vessel Details" },
      { path: "/api/vesselOwnerformById/:id", label: "Get Vessel Owner Details By ID" },
      { path: "/api/updateVesselDetails/:id", label: "Update Vessel Details by ID" },
      { path: "/api/getExpiringShipDetails", label: "Get Expiring Vessel Details" },
      { path: "/api/getvesselownerforcontract", label: "Get Vessel Owner Details for Contract" },
      { path: "/api/getcrewingAgentDetails", label: "Get Crewing Agent Details" },
      { path: "/api/vesselAgent", label: "Assign Vessel to Crewing Agent" },
      { path: "/api/vesselOwnercontract", label: "Contract Between BSM And VesselOwner" },
      { path: "/api/vesselOwner/approve/:id", label: "Approve Vessel Owner" },
      { path: "/api/vesselOwner/unapprove/:id", label: "Unapprove Vessel Owner" },
    ],
  },
  {
    group: "Adding Crew",
    routes: [
      { path: "/api/getcrewprofile", label: "Get All Crew Profiles" },
      { path: "/api/crewprofile", label: "Add Crew Profile" },
      { path: "/api/updateCrewProfileDetails/:id", label: "Update Crew Details" },
      { path: "/api/rankData", label: "Get Rank Details" },
      { path: "/api/createRank", label: "Add Rank" },
      { path: "/api/updateRank/:id", label: "Update Rank" },
    ],
  },
  {
    group: "Add Contract",
    routes: [
      { path: "/api/getAllContractData", label: "Get All Contract Details" },
      { path: "/api/getvesselownerforcontract", label: "Get Vessel Owner Details for Contract" },
      { path: "/api/crewingAgent/getApprovedCrewingAgent", label: "Get Approved Crewing Agents" },
      { path: "/api/getAllCrewingDetailswithoutForm1", label: "Get All Crew Details Without Form1" },
      { path: "/api/vesselformbyagentById/:id", label: "Get Vessel Form" },
      {path: "/api/contractDetails", label: "Add Contract"},
      { path: "/api/update/:contractId", label: "Update Contract" },
      {path: "/api/getAllCrewingDetails", label: "Update All Crewing Details"}
    ],
  },
  {
    group: "SignOn/SignOff",
    routes: [
      { path: "/api/getContractsWithForm1", label: "Get Contracts With Form1" },
      { path: "/api/statusAfterForm1", label: "Contract Status for SignOn/SignOff" },
      { path: "/api/getAllLatestStatusByType/:type", label: "Get Latest Status By Type" },
    ],
  },
  {
    group: "Contract Status",
    routes: [
      { path: "/api/approvecontract/:contractId", label: "Approve Contract" },
      { path: "/api/contract-status", label: "Add Contract Status" },
    ],
  },
  {
    group: "Crewing Agent",
    routes: [
      { path: "/api/getcrewingAgentDetails", label: "Get Crewing Agent Details" },
      { path: "/api/crewingAgentDetails", label: "Add Crewing Agent Details" },
      { path: "/api/uploadCrewContractDocuments", label: "Upload Crewing Agent Contract Documents" },
      { path: "/api/agentupdate/:id", label: "Update Crewing Agent Details by ID" },
      {path: "/api/crewingAgent/unapprovedCrewing/:id", label: " Deactivate Crewing Agent"},
      {path:"/api/crewingAgent/approvedCrewing/:id", label:"Activate Crewing Agent"},
    ],
  },
  {
    group: "Dashboard",
    routes: [
      {path: "/api/getTotalCounts", label: "Total Counts"},
      {path: "/api/getContractDetails", label: "All Contracts"},
      { path: "/api/firstContractAssignedTocrewingAgent/:id", label: "First Contract Assigned to Crewing Agent" },
      { path: "/api/getvesselAgent/:crewingAgentId", label: "Get Vessel Assigned to Crewing Agent" },
      { path: "/api/getContractDetailsByCrewAgentCount/:id", label: "Get Contract Details by Crew Agent ID" },
      { path: "/api/getContractStatusDetails", label: "Get Contract Status Details" },
      { path: "/api/getChargesDetailsByCrewingAgentId/:crewingAgentId", label: "Get Charges for Crewing Agent" },
      { path: "/api/CrewinngAccount/CrewingAgentADetailsccount/:crewingAgentId", label: "Get Crewing Agent Bank Account Details" },
      { path: "/api/payment//getCrewingAgentPaymentById/:crewingAgentId", label: "Get Crewing Agent Payment Details by ID" },
      { path: "/api/CrewinngAccount/CrewingAgentAccount", label: "Create Crewing Agent Bank Account" },
      { path: "/api/createChargesForCrewingAgent", label: "Create Charges for Crewing Agent" },
      { path: "/api/payment/makeCrewingAgentPayment", label: "Make Crewing Agent Payment" },
      { path: "/api/payment/paymentDone/:id", label: "Payment Done" },
    ],
  },
];
const SetPermissionPage = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [routeSearch, setRouteSearch] = useState("");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const res = await axios.get(`${baseURL}/api/getBSMUserList`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setUsers(res.data?.users || []);
    } catch {
      setError("Failed to load users.");
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchPermissions = async (userId) => {
    try {
      setLoadingPermissions(true);
      const res = await axios.get(`${baseURL}/api/permission/getPermissionsByUserId/${userId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setSelectedRoutes(res.data?.allowedRoutes || []);
    } catch {
      setSelectedRoutes([]);
      setError("No permission defined for this user.");
    } finally {
      setLoadingPermissions(false);
    }
  };

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    fetchPermissions(userId);
    setMessage("");
    setError("");
  };

  const handleRouteToggle = (path) => {
    setSelectedRoutes((prev) =>
      prev.includes(path) ? prev.filter((r) => r !== path) : [...prev, path]
    );
  };

  const handleSubmit = async () => {
    if (!selectedUserId || selectedRoutes.length === 0) {
      setError("Select a user and at least one route.");
      return;
    }
    try {
      const res = await axios.post(
        `${baseURL}/api/permission/set`,
        { userId: selectedUserId, allowedRoutes: selectedRoutes },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      toast.success(res.data.message || "Permissions updated successfully.");
    } catch {
      toast.error("Failed to update permissions.");
    }
  };

  const filteredRouteGroups = predefinedRoutes
    .map((group) => ({
      group: group.group,
      routes: group.routes.filter((r) =>
        r.label.toLowerCase().includes(routeSearch.toLowerCase())
      ),
    }))
    .filter((group) => group.routes.length > 0);

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography variant="h4" fontWeight={700} mb={3}>
          🔐 Set User Permissions
        </Typography>
        <Grid container spacing={4}>
          {/* User List */}
          <Grid item xs={12} md={3}>
            <Card sx={{ borderRadius: 4, height: "100%" }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  👤 Select User
                </Typography>
                <Divider sx={{ mb: 2 }} />
                {loadingUsers ? (
                  <Box textAlign="center"><CircularProgress /></Box>
                ) : (
                  <List sx={{ maxHeight: 600, overflowY: "auto" }}>
                    {users.map((user) => (
                      <Tooltip title={user.email} placement="right" key={user._id}>
                        <ListItem disablePadding>
                          <ListItemButton
                            selected={selectedUserId === user._id}
                            onClick={() => handleUserSelect(user._id)}
                            sx={{ borderRadius: 2, mb: 1 }}
                          >
                            <Avatar sx={{ mr: 2, bgcolor: "#C30B12" }}>
                              <PersonIcon />
                            </Avatar>
                            <ListItemText primary={user.username || user.email} />
                          </ListItemButton>
                        </ListItem>
                      </Tooltip>
                    ))}
                  </List>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Permission Toggles */}
          <Grid item xs={12} md={9}>
            <Card sx={{ borderRadius: 4 }}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="h6" fontWeight={600}>
                    ⚙️   Add Permissions for:{" "}
                    <strong>
                      {(() => {
                        const user = users.find((u) => u._id === selectedUserId);
                        return user ? `${user.username} (${user.userType})` : "User";
                      })()}
                    </strong>
                  </Typography>
                  <TextField
                    label="Search Routes"
                    variant="outlined"
                    size="small"
                    value={routeSearch}
                    onChange={(e) => setRouteSearch(e.target.value)}
                    sx={{ width: 300 }}
                  />
                </Stack>

                {loadingPermissions ? (
                  <Box textAlign="center"><CircularProgress /></Box>
                ) : (
                  filteredRouteGroups.map((group) => (
                    <Accordion key={group.group} defaultExpanded sx={{ mb: 1, borderRadius: 2 }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={600}>{group.group}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {group.routes.map((route) => (
                            <Grid item xs={12} sm={6} md={4} key={route.path}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={selectedRoutes.includes(route.path)}
                                    onChange={() => handleRouteToggle(route.path)}
                                  />
                                }
                                label={route.label}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))
                )}

                {error && <Alert severity="error" sx={{ mt: 3 }}>{error}</Alert>}
                {message && (
                  <Alert severity="success" icon={<CheckCircleIcon />} sx={{ mt: 3 }}>
                    {message}
                  </Alert>
                )}

                <Box textAlign="right" mt={4}>
                  <Button variant="contained" size="large" onClick={handleSubmit} sx={{backgroundColor:"#C30B12"}}>
                    💾 Save Permissions
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default SetPermissionPage;
